import nodeContentRenderer from './theme/NodeContentRenderer';
import treeNodeRenderer from './theme/TreeNodeRenderer';

export default {
  nodeContentRenderer,
  treeNodeRenderer,
  scaffoldBlockPxWidth: 32,
  rowHeight: 36,
};



// WEBPACK FOOTER //
// ./src/components/@browsbox-ui/bb-react-sortable-tree-theme/react-sortable-tree-theme.js